import type { ReservedWord } from '@/bindings/ReservedWord'

/**
 * Path words no restaurant or branch slug may take (URL scheme, 2026-09-01).
 * The `Record` keys force this runtime list to match the Rust enum exactly.
 */
const WORDS: Record<ReservedWord, true> = {
  api: true,
  app: true,
  assets: true,
  global: true,
  manage: true,
  system: true,
}

export function isReservedWord(value: string): value is ReservedWord {
  return Object.hasOwn(WORDS, value)
}
